import { render, staticRenderFns } from "./RejectedCompaniesTab.vue?vue&type=template&id=59521c5a&scoped=true&"
import script from "./RejectedCompaniesTab.vue?vue&type=script&lang=js&"
export * from "./RejectedCompaniesTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59521c5a",
  null
  
)

export default component.exports